module.exports = __webpack_public_path__ + "img/slide_5.b5cb7cc7.png";